import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { Colors } from '../../util/util'

const styles = {
  scrollContainer: {
    flexGrow: 1,
  },
  maincontainer: {
    marginHorizontal: 16,
    marginVertical: 8,
    backgroundColor: 'WHITE',
    borderRadius: 8,
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    ph: 16,
    f:1,
  } as BoxProps,
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: Colors.LIGHT_GREY,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    backgroundColor: 'WHITE',
    padding: 16,
    // marginHorizontal: 18,
    border: `1px solid ${Colors.SECONDARY_GREY}`,
    justifyContent: 'space-between',
    borderRadius: 4,
    position: 'relative',
    flexGrow: 1,
  } as BoxProps,
  stickyHeader: ({
    position: 'sticky',
    top: -2,
    paddingBottom: 16,
    backgroundColor: 'white',
    zIndex: 100,
    marginTop: -16,
  } as unknown) as BoxProps,
  modal: {
    position: 'absolute',
    elevation: 2,
    shadowOpacity: 1,
    opacity: 1,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F' as ColorOptions,
    zIndex: 1,
    align: 'center',
    justify: 'center',
    borderColor: 'GRAY_BORDER',
    backgroundColor: '#00000080' as ColorOptions,
  } as BoxProps,
  tableContainer: (isLoading: boolean) =>
    ({
      alignContent: 'center',
      marginTop: isLoading ? 24 : undefined,
    } as BoxProps),
  highlightContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginVertical: 16,
  } as BoxProps,
  emptyContainer: {
    alignContent: 'center',
    flex: 1,
  } as BoxProps,
  dropdownStyle: (XAxisPos: number | undefined, yAxisPos: number | undefined, rightPos: number | undefined) =>
    ({
      position: 'absolute',
      flex: 1,
      shadowColor: 'BLACK_LIGHT',
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.3,
      shadowRadius: 10,
      elevation: 2,
      left: XAxisPos,
      top: yAxisPos ? yAxisPos + 15 : undefined,
      borderRadius: 12,
      backgroundColor: 'BLUE',
      borderColor: 'SECONDARY_GREY',
      alignSelf: 'center',
      right: rightPos,
    } as BoxProps),
    overlayStyle: {
      backgroundColor: 'TRANSPARENT',
      width: '100%',
      height: '100%',
      justifyContent: 'center',
    } as BoxProps,
}
export { styles }
